<div class="empty-status-shopping-cart">
    <div class="empty-status-shopping-cart__icon">
        <ridango-ui-icons name="emptyBasket"></ridango-ui-icons>
    </div>

    <h1 class="empty-status-shopping-cart__title">{{ 'EMPTY_STATUS_SHOPPING_EMPTY_BASKET' | translate }}</h1>
    <div class="empty-status-shopping-cart__description">{{ 'EMPTY_STATUS_SHOPPING_DESCRIPTION' | translate }}</div>

    <div class="empty-status-shopping-cart-buttons">
        <ng-content></ng-content>
    </div>
</div>
